import { render, staticRenderFns } from "./CampaignAudience.vue?vue&type=template&id=39b44ae4&scoped=true&"
import script from "./CampaignAudience.vue?vue&type=script&lang=js&"
export * from "./CampaignAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b44ae4",
  null
  
)

export default component.exports